/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Strength_Table_LevelInputs */

const en_us2_exercise_personal_strength_table_level = /** @type {(inputs: Exercise_Personal_Strength_Table_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Level`)
};

const pt_br2_exercise_personal_strength_table_level = /** @type {(inputs: Exercise_Personal_Strength_Table_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nível`)
};

const es_419_exercise_personal_strength_table_level = /** @type {(inputs: Exercise_Personal_Strength_Table_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nivel`)
};

const pt_pt2_exercise_personal_strength_table_level = /** @type {(inputs: Exercise_Personal_Strength_Table_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nível`)
};

const fr_fr2_exercise_personal_strength_table_level = /** @type {(inputs: Exercise_Personal_Strength_Table_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niveau`)
};

const de_de2_exercise_personal_strength_table_level = /** @type {(inputs: Exercise_Personal_Strength_Table_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niveau`)
};

const it_it2_exercise_personal_strength_table_level = /** @type {(inputs: Exercise_Personal_Strength_Table_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Livello`)
};

/**
* | output |
* | --- |
* | "Level" |
*
* @param {Exercise_Personal_Strength_Table_LevelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_strength_table_level = /** @type {((inputs?: Exercise_Personal_Strength_Table_LevelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Strength_Table_LevelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_strength_table_level(inputs)
	if (locale === "es-419") return es_419_exercise_personal_strength_table_level(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_strength_table_level(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_strength_table_level(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_strength_table_level(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_strength_table_level(inputs)
	return en_us2_exercise_personal_strength_table_level(inputs)
});
export { exercise_personal_strength_table_level as "exercise-personal.strength_table_level" }